import React, {Component} from 'react';
import EditableTable from "@components/Table/EditableTable";
import {FacilityColumns, FacilityProps} from "@containers/management/Facility/FacilityColumns";
import _ from "lodash";
import actions from "@redux/facility/actions";
import {connect} from "react-redux";
import {api} from "@redux/api";
import {FacilityFormFields} from "@containers/management/Facility/FacilityFormFields";
import GoogleMaps from "@components/GoogleMaps";
import {FacilityColumnsCompact} from "@containers/management/Facility/FacilityColumnsCompact";

import {removeDuplicates} from "@components/help";
import authActions from "@redux/auth/actions";
import CustomUserRelated from "@containers/management/Facility/CustomUserRelated/CustomUserRelated";
import { withRouter } from "@/router/withRouter";
import { useAuthEditable, useAuthFullAccess } from '@/hooks/use-auth';
import { Form, Input } from "antd";
import Select from "@components/ResponsiveSelect";

class Facility extends Component {

    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.filterFormRef = React.createRef();
        this.state = {
            data: [],
            isLoading: false,
            tableRef: null,
            filterDescription: null,
            name: '',
            filtered_category: null,
            filtered_company: null,
        }
    }

    normalizeMultiValue = (value) => {
        if (Array.isArray(value)) return value.filter((item) => item != null && item !== "");
        if (typeof value === "string") return value.split(",").filter(Boolean);
        if (value == null || value === "") return [];
        return [value];
    }

    appendQueryParam = (parts, key, value) => {
        if (Array.isArray(value)) {
            value
                .filter((item) => item != null && item !== "")
                .forEach((item) => this.appendQueryParam(parts, key, item));
            return;
        }
        if (value == null || value === "") return;
        parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }

    buildFacilityQuery = (baseQuery = "", extraParams = {}) => {
        const cleanBaseQuery = String(baseQuery || "").replace(/^\?/, "").replace(/^&/, "");
        const parts = cleanBaseQuery ? [cleanBaseQuery] : [];

        Object.entries(extraParams).forEach(([key, value]) => {
            this.appendQueryParam(parts, key, value);
        });

        return parts.join("&");
    }


    handleCreateFacility = (body) => {

        let parent = this.props.relatedList;
        if (parent) {
            body['company'] = this.props.relatedId;
        }

        if (this.props.SelectedCompany) {
            body['company'] = this.props.SelectedCompany;
        }

        if (!body['longitude']) {
            body['longitude'] = 0
        }
        if (!body['latitude']) {
            body['latitude'] = 0
        }
        return api.createFacility(body).then(
            response => {
                // this.refreshFacilityOption(response.data);
                this.refreshUserInfo();
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handleDeleteFacility = (id) => {
        return api.deleteFacility(id).then(
            response => {

                this.refreshUserInfo();
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handleBulkInsert = (body) => {
        return api.bulkFacilityInsert(body).then(
            response => {
                return response.data
            }
        ).catch(error => {
            return (
                error
            )
        });
    }

    handleBulkDelete = (body) => {
        return api.bulkDeleteFacility(body).then(
            response => {
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handOnlineSave = (key, row) => {
        // console.log('row0', row, this.props.SelectedCompany)

        if (this.props.SelectedCompany) {
            row['company'] = this.props.SelectedCompany;
        }
        row['user'] = []
        if (!row['longitude']) {
            row['longitude'] = 0
        }
        if (!row['latitude']) {
            row['latitude'] = 0
        }

        let parent = this.props.relatedList;
        if (parent) {
            row['company'] = this.props.relatedId;
        }

        if(Array.isArray(row.address)) {
            delete row.address
        }

        return api.editFacility(key, row).then(
            response => {
                // this.refreshFacilityOption(response.data)
                this.refreshUserInfo(key);


                return response
            }
        ).catch(error => (
            error
        ));
    }


    handleFilter = (query) => {

        const filteredCompanyLabels = this.normalizeMultiValue(this.state.filtered_company)
            .map((companyId) => this.state.company_options?.find((option) => String(option.value) === String(companyId))?.label || companyId);
        const {filtered_category} = this.state;
        let filterDescription = [filteredCompanyLabels.join(', '), this.normalizeMultiValue(filtered_category).join(', ')]
            .filter(Boolean)
            .join(' ');

        filterDescription = (filterDescription.length > 0 && filterDescription !== ' ')
            ? `filtered by: ${filterDescription}`
            : '';

        this.setState({
            isLoading: true,
            filterDescription: filterDescription
        })

        // 构建过滤查询参数
        let filterQuery = this.buildFacilityQuery('', {
            name: this.state.name,
            company: this.state.filtered_company,
            category: this.state.filtered_category,
        });

        // 处理关联列表
        let parent = this.props.relatedList;
        if (parent && this.props.relatedId) {
            filterQuery += (filterQuery ? '&' : '') + 'companyId=' + this.props.relatedId;
        }

        // 拼接所有查询参数
        let query_new = [
            query,
            filterQuery
        ].filter(Boolean).join('&');

        // 清理多余的 & 符号
        query_new = query_new.replace(/&+/g, '&').replace(/^&|&$/g, '');

        return api.filterFacility(query_new).then(
            response => {
                let dataSource = response.data.results
                // this.refreshUserInfo();
                return {
                    data: dataSource,
                    success: true,
                    total: response.data.count
                }
            }
        ).catch(error => (
            error
        ));
    }

    getFacility = (data) => {

        let category_options = [];
        // status_options.push({label: 'All', value:'All'});

        let company_options = [];
        // priority_options.push({label: 'All', value:'All'});
        for (let i = 0; i < data.length; i++) {
            company_options.push({label: data[i].company_name, value: data[i].company});
            const categoryName = data[i].facility_category_name || data[i].category;
            if (categoryName) {
                category_options.push({label: categoryName, value: categoryName});
            }
        }


        this.setState({
            data,
            isLoading: false,
            company_options: removeDuplicates(company_options),
            category_options: removeDuplicates(category_options),
        })


    }

    refreshUserInfo = (key) => {
        const that = this;
        return api.refreshUserInfo().then(
            response => {
                let data = response.data;
                let facilities = _.get(data, 'user_facilities', []);
                this.refreshFacilityOption(facilities);
                this.props.updateUserInfoRequest(data);
                if(that.props.selectedId === key) {
                    const currentFacility = facilities.find(f => f.id === that.props.selectedId)
                    that.props.UpdateSelectedFacility({
                        key: currentFacility.id + '',
                        Id: currentFacility.id,
                        value: currentFacility.name,
                        record: currentFacility,
                    })
                }
            }
        ).catch(error => (
            error
        ))
    }
    onNew = () => {
        this.props.navigate('/admin/create-facility');
    }

    refreshFacilityOption = (facilities) => {


        let facilityOptions = [];
        facilities.forEach(facility => {
            facilityOptions.push(
                {
                    Id: facility.id, label: (
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                            }}
                        >
                            {facility.name}
                            <span>{facility.company}</span>
                        </div>
                    ), value: facility.name, record: facility, index: facility.id
                }
            )
        })

        this.props.setFacilityRequest(facilityOptions)
    }

    gettableRef = (tableRef) => {
        console.log('tableRef', tableRef)
        this.setState({
            tableRef
        })
    }

    renderFilter = () => {
        return null
    }

    setFilters = (e) => {
        this.setState({
            filtered_company: e.Company ? this.normalizeMultiValue(e.Company) : [],
            filtered_category: e.Category ? this.normalizeMultiValue(e.Category) : [],
        }, function () {
            this.refresh(false)
        })
    }
    refresh = (needRequest) => {
        return this.tableRef?.current?.refresh(needRequest);
    };
    handleSearchSelect = (e) => {
        this.setState({
            name: e
        }, function () {
            this.refresh(false)
        })

    }
    handleSearch = (e, record) => {
        this.setState({
            name: e?.target ? e.target.value : e
        }, function () {
            this.refresh(false)
        })
    }

    resetFilters = () => {
        if (this.filterFormRef?.current) {
            this.filterFormRef.current.resetFields();
        }
        this.setState({
            name: '',
            filtered_company: [],
            filtered_category: [],
            filterDescription: null,
        }, function () {
            this.refresh(false)
        })
    }

    renderSearches = () => {
        return (
            <Form
                ref={this.filterFormRef}
                className={'filter-form'}
                initialValues={{
                    name: this.state.name,
                    Company: this.normalizeMultiValue(this.state.filtered_company),
                    Category: this.normalizeMultiValue(this.state.filtered_category),
                }}
                autoComplete="off"
            >
                <Form.Item label={'Name'} name="name">
                    <Input
                        allowClear
                        style={{ width: "100%" }}
                        placeholder={'Name'}
                        value={this.state.name}
                        onChange={this.handleSearch}
                    />
                </Form.Item>

                <Form.Item label={'Company'} name={'Company'}>
                    <Select
                        mode="multiple"
                        allowClear
                        showSearch
                        className={'min-multi-selector'}
                        style={{ width: "100%" }}
                        placeholder={'Company'}
                        value={this.normalizeMultiValue(this.state.filtered_company)}
                        options={this.state.company_options || []}
                        onChange={(value) => this.setFilters({
                            Company: value,
                            Category: this.state.filtered_category,
                        })}
                    />
                </Form.Item>

                <Form.Item label={'Category'} name={'Category'}>
                    <Select
                        mode="multiple"
                        allowClear
                        showSearch
                        className={'min-multi-selector'}
                        style={{ width: "100%" }}
                        placeholder={'Category'}
                        value={this.normalizeMultiValue(this.state.filtered_category)}
                        options={this.state.category_options || []}
                        onChange={(value) => this.setFilters({
                            Company: this.state.filtered_company,
                            Category: value,
                        })}
                    />
                </Form.Item>
            </Form>
        )
    }

    RenderCustomUserRelated = (relatedId) => {
        return (<CustomUserRelated relatedId={relatedId} />)
    }

    render() {

        let parent = this.props.relatedList;
        let columns = [];
        if (parent) {
            columns = FacilityColumnsCompact()
        } else {
            columns = FacilityColumns()
        }

        return (

            <div className="m-5">
                <EditableTable
                    ref={this.tableRef}
                    columns={columns}
                    data={this.state.data}
                    columnProps={FacilityProps}
                    formFields={FacilityFormFields(this.state.tableRef)}
                    formRelated={this.RenderCustomUserRelated}
                    getRecord={this.getFacility}
                    createRecords={this.handleCreateFacility}
                    deleteRecord={this.handleDeleteFacility}
                    bulkInsert={this.handleBulkInsert}
                    bulkDelete={this.handleBulkDelete}
                    handOnlineSave={this.handOnlineSave}
                    relatedList={this.props.relatedList}
                    hide_date={true}
                    hide_imports={true}
                    hide_search={true}
                    hid_new={this.props.Role === '4.0'}
                    new_text={'Create Facility'}
                    onNew={this.onNew}
                    isChat={false}
                    isRelated={true}
                    isAttachments={false}
                    isMetrics={true}
                    getFormRef={this.gettableRef}

                    handleFilter={this.handleFilter}
                    renderFilter={this.renderFilter}
                    resetFilters={this.resetFilters}
                    setFilters={this.setFilters}

                    filterDescription={this.state.filterDescription}
                    canDelete={this.props.fullAccess}
                    renderSearches={this.renderSearches}
                    defaultDisplayColumns={{
                        "latitude": {
                            "show": false
                        },
                        "longitude": {
                            "show": false
                        }
                    }}
                />
                {/*<AddressLookup />*/}
                {!this.props.relatedList ?
                    <div className='mt-5'>
                        <GoogleMaps data={this.state.data} height={'40vh'} zoom={3.5}/>
                    </div>
                    : ''}
            </div>

        );
    }
}

const mapStateToProps = state => {
    return {
        Facility: _.get(state.Facility, 'data'),
        SelectedCompany: _.get(state.Company, 'selectedCompany.Id'),
        Role: _.get(state, 'Auth.role') ? Object.keys(_.get(state, 'Auth.role'))[0] : null,
        selectedId: _.get(state.Facility, 'selected.Id')
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setFacilityRequest: (e) => dispatch(actions.FacilitySuccess(e)),
        updateUserInfoRequest: (e) => dispatch(authActions.userInfoUpdated(e)),
        UpdateSelectedFacility: (e) => dispatch(actions.SelectedFacility(e))
    }
}

const withHooks = (Component) => {
    const NewComponent = (props) => {
        const editable = useAuthEditable('facility');
        const fullAccess = useAuthFullAccess('facility');

        return <Component {...props} editable={editable} fullAccess={fullAccess} />;
    };
    return NewComponent;
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(withHooks(Facility)));
